<script lang="ts">
    import type {PublicStatsData} from '../../types';
    import {Bar} from 'svelte-chartjs';
    import {getLocalization} from 'core/svelte-context/context';
    import {getColorFromString} from 'shared/utils/color-util';
    import KpTitledSection from 'shared/layouts/KpTitledSection.svelte';
    import {
        Chart,
        Title,
        Tooltip,
        BarElement,
        CategoryScale,
        LinearScale,
    } from 'chart.js';

    export let statsData: PublicStatsData;
    const localize = getLocalization();

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y' as const,
        barThickness: 36,
        plugins: {
            legend: {
                display: false
            }
        }
    };

    function generateMovementsData(data: PublicStatsData) {
        return {
            labels: data.stats.result.movementsCounts.counts.map((movement) => movement.name),
            datasets: [
                {
                    data: data.stats.result.movementsCounts.counts.map((movement) => movement.value),
                    backgroundColor: data.stats.result.movementsCounts.counts.map((movement) => getColorFromString(movement.name, 70, 0.8)),
                    borderColor: data.stats.result.movementsCounts.counts.map((movement) => getColorFromString(movement.name, 70)),
                    borderWidth: 1
                },
            ],
        };
    }

    function calculateChartHeight(data: PublicStatsData): number {
        return 50 * data.stats.result.movementsCounts.counts.length;
    }

    Chart.register(Title, Tooltip, BarElement, CategoryScale, LinearScale);
</script>

<KpTitledSection title="{localize(/* @kp-localization statistiky.pohybyCtenaru */ 'statistiky.pohybyCtenaru')}"
                 additionalClasses="stats-movements-graph"
                 headingType="h3">

    {#if statsData.stats.result.movementsCounts.counts.length > 0}
        <div class="graph-container" style:height="{calculateChartHeight(statsData)}px">
            <Bar data="{generateMovementsData(statsData)}" {options}/>
        </div>
    {:else}
        <span class="text-center">
            {localize(/* @kp-localization commons.ZadnePolozky */ 'commons.ZadnePolozky')}
        </span>
    {/if}
</KpTitledSection>

<style lang="less">
    .graph-container {
        width: 100%;
    }
</style>